<template>
  <div>
    <LoaderMaskComponent v-if="lyLoading"/>
    <div v-else>
      <breadcrumb-component
          :moduleTitle="'Service management'"
          :mainTitle="'Disk'"
          :subTitle="'Disk list'"
      />
      <div class="row">
        <div class="col-md-12">
          <div class="card card_full_window vm_list_page ">
            <div class="card-body">
              <div class="common_content_wrap">
                <div class="common_content_left">
                  <ServiceLeftMenuComponent/>
                </div>
                <div class="common_content_right">
                  <div v-if="hasPagePermission('Disk')" class="vm_list_content">
                    <div class="d_flex_start pt_10 pb_10">
                      <div class="common_dropdown dropdown_no_radius mr_10" v-if="customer.selected_service_id == 1 || customer.selected_service_id == 2">
                        <div class="btn-group dropdown-center dropdown-fill-text">
                          <button type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown"
                          aria-expanded="false">
                            <span v-if="selectedPlatform">{{ selectedPlatform.value }}</span>
                            <span v-else>All Platform</span>
                          </button>
                          <ul class="dropdown-menu no_arrow">
                            <button class="dropdown-item" type="button" @click.prevent="changePlatform(null)"><span>All Platform</span>
                            </button>
                            <li v-for="(serverPlatform, index) in serverPlatforms" :key="'server_platform_'+index"
                                @click.prevent="changePlatform(serverPlatform)">
                              <button class="dropdown-item" type="button"><span>{{ serverPlatform.value }}</span></button>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="common_dropdown dropdown_no_radius ">
                        <div class="btn-group dropdown-center dropdown-fill-text">
                          <button type="button" class="btn btn-secondary dropdown-toggle " data-bs-toggle="dropdown"
                                  aria-expanded="false">
                            <span v-if="selectedRegion">{{ selectedRegion.name }}</span>
                            <span v-else>All Region</span>
                          </button>
                          <ul class="dropdown-menu no_arrow">
                            <button class="dropdown-item" type="button" @click.prevent="changeRegion(null)"><span>All Region</span>
                            </button>
                            <li v-for="(serverRegion, index) in serverRegions" :key="'server_region_'+index"
                                @click.prevent="changeRegion(serverRegion)">
                              <button class="dropdown-item" type="button"><span>{{ serverRegion.name }}</span></button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="d_flex_start pt_10 pb_10">
                      <router-link v-if="hasPermission('Create') && customer.selected_service_id && customer.selected_service_id != 1" :to="{name: 'create_cloud_disk'}">
                        <button type="button" class="btn btn-outline-primary btn-sm mr_15 width_100p">Disk Create
                        </button>
                      </router-link>
                      <button
                          v-if="hasPermission('Attach')"
                          type="button"
                          class="btn btn-outline-success btn-sm mr_15 width_100p"
                          @click.prevent="openAttachModal()"
                          :disabled="!canAttach"
                      >
                        Attach
                      </button>
                      <button
                          v-if="hasPermission('Detach')"
                          type="button"
                          class="btn btn-outline-danger btn-sm mr_15 width_100p"
                          @click.prevent="handleDetach()"
                          :disabled="canDetach"
                      >
                        Detach
                      </button>
                      <button
                          v-if="hasPermission('Delete')"
                          type="button"
                          class="btn btn-outline-danger btn-sm width_100p"
                          @click.prevent="deleteTheRecord()"
                          :disabled="!canDelete"
                      >
                        Delete
                      </button>
                      <button
                          type="button"
                          class="btn btn-outline-primary btn-sm ml_15 width_100p"
                          @click.prevent="loadData()"
                      >
                        Refresh
                      </button>
                    </div>
                    <cloud-table-component
                        :columns="columns"
                        :rows="cloudDisks"
                        :sortable="sortable"
                        :pagination="pagination"
                        @sorting="sorting"
                        @pageChanged="pageChanged">

                      <template v-slot:id="{ row }">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" :id="'action_'+row.id"
                                 @focus="checkSingleServer(row, $event)" :checked="selectedCloud?.id === row.id">
                          <label class="form-check-label" :for="'action_'+row.id"></label>
                        </div>
                      </template>

                      <template v-slot:space="{ row }">
                        <div>{{ row.space }}GB</div>
                      </template>

                      <template v-slot:status="{ row }">
                        <span v-if="row.status == 'processing'" class="color_warning">Processing</span>
                        <span v-if="row.status == 'running'" class="color_success">Running</span>
                        <span v-if="row.status == 'stopped'" class="color_danger">Stopped</span>
                      </template>

                      <template v-slot:kt_platform="{ row }">
                        <span v-if="row.kt_platform == 'g'" class="color_success">G</span>
                        <span v-if="row.kt_platform == 'd'" class="color_warning">D</span>
                      </template>
                      
                      <template v-slot:action="{ row }">
                        <button v-if="hasPermission('View')" type="button" class="btn btn-outline-primary btn-sm mr_15 width_100p"
                                @click.prevent="openModal(row)">Details
                        </button>
                      </template>
                    </cloud-table-component>
                  </div>
                  <div v-else>
                    <p>You do not have permission to view this content.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DetailsModal
          v-if="isShowModal"
          :isShowModal="isShowModal"
          :modalData="modalData"
          @closeModal="closeModal"
      />
      <AttachModal
          v-if="showAttachModal"
          :showAttachModal="showAttachModal"
          :selectedDisk="selectedDisk"
          @closeModal="closeAttachModal"
      />
    </div>
  </div>
</template>
<script>
import {checkPermission} from "@/mixins/permissionsHelper";
import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";
import ServiceLeftMenuComponent from "../ServiceLeftMenuComponent.vue";
import CloudTableComponent from '@/components/shared/CloudTableComponent.vue';
import BreadcrumbComponent from '@/components/shared/BreadcrumbComponent.vue';
import DetailsModal from "./DetailsModal.vue";
import AttachModal from "./AttachModal.vue";
import {mapGetters} from "vuex";
import {echo} from "@/services/echo";

export default {
  name: 'cloud-disks',
  components: {
    LoaderMaskComponent,
    ServiceLeftMenuComponent,
    CloudTableComponent,
    BreadcrumbComponent,
    DetailsModal,
    AttachModal
  },
  data() {
    return {
      lyLoading: false,
      serverRegions: [],
      cloudDisks: [],
      selectedRegion: null,
      selectedPlatform: null,
      filter: {
        kt_platform: '',
        server_region_id: '',
      },
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'cloudService.name,name,cloudServer.server_name,status,serverRegion.name,billing_type',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      },
      sortable: {
        order: 'created_at',
        sort: 'desc'
      },
      columns: [
        {
          label: "",
          field: "id",
          sortable: false,
          slot: true,
        },
        {
          label: "Service",
          field: "cloudService.name",
          sortable: true,
        },
        {
          label: "Name",
          field: "name",
          sortable: true,
        },
        {
          label: "Status",
          field: "status",
          sortable: true,
          slot: true
        },
        {
          label: "Server",
          field: "cloudServer.server_name",
          sortable: true,
        },
        {
          label: "Region",
          field: "serverRegion.name",
          sortable: true,
        },
        {
          label: "Type",
          field: "disk_type",
          sortable: true,
        },
        {
          label: "Product",
          field: "disk_product_type",
          sortable: true,
        },
        {
          label: "Space",
          field: "space",
          sortable: true,
          slot: true
        },
        // {
        //   label: "IOPS",
        //   field: "iops",
        //   sortable: true,
        // },
        {
          label: "Billing type",
          field: "billing_type",
          sortable: true,
        },
        {
          label: "Kt platform",
          field: "kt_platform",
          sortable: true,
          slot: true,
        },
        {
          label: "Started at",
          field: "started_at",
          sortable: true,
        },
        {
          label: "Action",
          field: "action",
          sortable: false,
          slot: true,
        },
      ],
      update: {
        kt_platform: '',
        server_region_id: '',
      },
      pagination: null,
      selectedCloud: null,
      isShowModal: false,
      modalData: null,
      showAttachModal: false,
      selectedDisk: null,
      selectedService: null
    }
  },
  computed: {
    ...mapGetters({
      customer: 'auth/getUserInfo',
      permissions: 'serverPermissions/getServicePermission',
      services: 'auth/getCustomerServices',
    }),
    canAttach() {
      return this.selectedCloud && this.selectedCloud.disk_type !== 'default' && !this.selectedCloud?.cloud_server_id;
    },
    canDetach() {
      return this.selectedCloud && this.selectedCloud.disk_type === 'default' || !this.selectedCloud?.cloud_server_id;
    },
    canDelete() {
      return this.selectedCloud && this.selectedCloud?.disk_type !== 'default' && !this.selectedCloud?.cloud_server_id;
    },
    serverPlatforms(){
      if(this.customer.g_platform && this.customer.d_platform){
        return [
          {label: 'g', value: 'G'},
          {label: 'd', value: 'D'},
        ];
      }else if(this.customer.g_platform){
        return [
          {label: 'g', value: 'G'},
        ];
      }else if(this.customer.d_platform){
        return [
          {label: 'd', value: 'D'},
        ];
      }else{
        return [
          {label: 'g', value: 'G'},
        ];
      }
    }
  },
  watch: {
    $route(to, from) {
      if (to.name == from.name && !window._.isEqual(to, from)) {
        this.setQueryData(this.getAllQueryParams())
        this.loadData()
      }
    },
    customer: {
      handler(newVal, oldVal) {
        if (newVal?.selected_service_id !== oldVal?.selected_service_id) {
          // Perform actions when selected_service_id changes
          const newService = this.services.find((item) => item.id === parseInt(newVal?.selected_service_id));
          if (newService) {
            this.selectedService = newService
          } else {
            console.log('No matching service found');
          }
        }
        this.loadServerRegions();
        this.loadData();
      },
      deep: true, // Watch for changes in nested properties
      immediate: true,
    }
  },
  created() {
    const query = this.getAllQueryParams()
    if (query.page) {
      this.setQueryData(query)
    }
    this.loadData();
    this.loadServerRegions();
  },
  mounted() {
    if(this.$route.query.kt_platform){
      let platform = this.serverPlatforms.filter(item => item.label == this.$route.query.kt_platform)
      if(platform && platform.length > 0){
        this.selectedPlatform = platform[0]
      }
    }
    this.diskSocketInit()
  },
  beforeUnmount() {
    echo.leaveChannel(`kt_cloud_disk_records.${this.customer.id}`);
  },
  methods: {
    diskSocketInit(){
      echo.channel(`kt_cloud_disk_records.${this.customer.id}`)
          .listen('.kt_cloud_disk_records.updated', () => {
            this.loadData();
            // if (event.deleted_at) {
            //   const index = this.cloudDisks.findIndex(r => r.id === event.id);
            //   if (index !== -1) {
            //     this.cloudDisks.splice(index, 1);
            //   }
            // } else {
            //   const index = this.cloudDisks.findIndex(r => r.id === event.id);
            //   if (index !== -1) {
            //     this.cloudDisks[index] = { ...this.cloudDisks[index], ...event };
            //   }
            // }
          });
    },
    setQueryData(query) {
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page
      }

      this.filter = {
        kt_platform: query.kt_platform,
        server_region_id: query.server_region_id,
      }

      this.sortable = {
        order: query.sort,
        sort: query.sort_order
      }
    },
    resetAll() {
      this.sortable = {
        order: 'created_at',
        sort: 'desc'
      }

      this.filter = {
        kt_platform: '',
        server_region_id: '',
      }

      this.queryParams = {
        page: 1,
        search: '',
        search_columns: 'cloudService.name,name,cloudServer.server_name,status,serverRegion.name,billing_type',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      }

      this.changeRoute();
      this.loadData();
    },
    searchQuery() {
      this.changeRoute();
    },
    sorting({column, order}) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute()
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute()
    },
    changeRoute() {
      this.$router.push({name: this.$route.name, query: {...this.queryParams, ...this.filter}})
    },
    loadData() {
      this.lyLoading = true
      this.axios.get('/cloud-disks', {
        params: {...this.queryParams, ...this.filter}
      }).then((response) => {
        this.cloudDisks = response.data.data;
        this.pagination = response.data.meta;
      }).finally(() => {
        this.lyLoading = false;
      })
    },
    loadServerRegions() {
      this.axios.get('/server-regions')
      .then(({data}) => {
        this.serverRegions = data.data
        if(this.$route.query.server_region_id){
          let region = this.serverRegions.filter(item => item.id == this.$route.query.server_region_id)
          if(region && region.length > 0){
            this.selectedRegion = region[0]
          }
        }
      })
    },
    changePlatform(platform) {
      if (platform) {
        this.selectedPlatform = platform
      } else {
        this.selectedPlatform = ''
      }

      this.queryParams.page = 1;
      this.filter.kt_platform = this.selectedPlatform ? this.selectedPlatform.label : '';
      this.changeRoute()
    },
    changeRegion(region) {
      if (region) {
        this.selectedRegion = region
      } else {
        this.selectedRegion = ''
      }

      this.queryParams.page = 1;
      this.filter.server_region_id = this.selectedRegion ? this.selectedRegion.id : '';
      this.changeRoute()
    },
    checkSingleServer(server, event) {
      event.target.blur();
      if (this.selectedCloud?.id === server.id) {
        this.selectedCloud = null;
      } else {
        this.selectedCloud = server;
      }
    },
    deleteTheRecord(){
      if (this.selectedCloud?.storage_cloud_type === 'vlan-cloud'){
        this.deleteVlanStoreRecord()
      } else {
        this.deleteRecord()
      }
    },
    deleteRecord() {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/cloud-disks/' + this.selectedCloud.id)
              .then((response) => {
                if (response.data.success) {
                  this.selectedCloud = null;
                  this.showSuccessMsg(response.data.message);
                  this.loadData();
                } else {
                  this.$swal({
                    text: response.data.message,
                    showCancelButton: false,
                    confirmButtonText: 'Close!',
                    confirmButtonColor: '#dd4b39',
                    reverseButtons: true
                  })
                }
              });
        }
      });
    },
    deleteVlanStoreRecord() {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/proxmox/delete-storage/' + this.selectedCloud.id)
              .then((response) => {
                if (response.data.success) {
                  this.selectedCloud = null;
                  this.showSuccessMsg(response.data.message);
                  this.loadData();
                } else {
                  this.$swal({
                    text: response.data.message,
                    showCancelButton: false,
                    confirmButtonText: 'Close!',
                    confirmButtonColor: '#dd4b39',
                    reverseButtons: true
                  })
                }
              });
        }
      });
    },
    openModal(data) {
      this.modalData = data
      this.isShowModal = true;
    },
    closeModal() {
      this.loadData();
      this.modalData = false
      this.isShowModal = false;
    },
    openAttachModal() {
      this.selectedDisk = this.selectedCloud
      this.showAttachModal = true
    },
    closeAttachModal(value) {
      if (value) {
        this.loadData();
        this.selectedDisk = null
        this.selectedCloud = null
        this.showAttachModal = false
      } else {
        this.showAttachModal = false
      }
    },
    handleDetach(){
      if (this.selectedService?.slug === 'vlan24-cloud') {
        console.log('vlan cloud')
        this.detachVlanCloudServer()
      } else {
        console.log('kt cloud')
        this.detachServer()
      }
    },
    detachServer() {
      this.$swal({
        title: 'Are you sure want to detach?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, detach it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          let formData = {
            cloud_disk_id: this.selectedCloud.id,
          }
          if(this.selectedCloud.kt_platform == 'g'){
            this.axios.post('/detach-disk-from-server', formData)
            .then((response) => {
              if (response.data.success) {
                this.selectedCloud = null;
                this.showSuccessMsg(response.data.message);
                this.loadData();
              } else {
                this.$swal({
                  text: response.data.message,
                  showCancelButton: false,
                  confirmButtonText: 'Close!',
                  confirmButtonColor: '#dd4b39',
                  reverseButtons: true
                })
              }
            });
          }else{
            this.axios.post('/detach-d-disk-from-server', formData)
            .then((response) => {
              if (response.data.success) {
                this.selectedCloud = null;
                this.showSuccessMsg(response.data.message);
                this.loadData();
              } else {
                this.$swal({
                  text: response.data.message,
                  showCancelButton: false,
                  confirmButtonText: 'Close!',
                  confirmButtonColor: '#dd4b39',
                  reverseButtons: true
                })
              }
            });
          }
        }
      });
    },
    detachVlanCloudServer(){
      this.$swal({
        title: 'Are you sure want to detach?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, detach it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.post(`/proxmox/detach-disk-from-vm/${this.selectedCloud.id}`)
              .then((response) => {
                if (response.data.success) {
                  this.selectedCloud = null;
                  this.showSuccessMsg(response.data.message);
                  this.loadData();
                } else {
                  this.$swal({
                    text: response.data.message,
                    showCancelButton: false,
                    confirmButtonText: 'Close!',
                    confirmButtonColor: '#dd4b39',
                    reverseButtons: true
                  })
                }
              });
        }
      })
    },
    hasPermission(action) {
      let diskIndex = this.permissions?.cloud_sub_service.indexOf('Disk')
      let entity = this.permissions?.cloud_sub_service[diskIndex];
      return checkPermission(this.permissions, entity, action);
    },
    hasPagePermission(entityName) {
      return this.permissions?.cloud_sub_service?.includes(entityName) || this.permissions?.cloud_sub_service?.includes('All');
    },
  }
}
</script>